import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

const OFFICE_ID_HELP = "Used only if none of your Agent MLS IDs return any listings.";

// The Office MLS ID column's header, with what the ID is for.
const Component: React.FC<WithStyles<typeof styles>> = ({ classes = {} }) => {
	return (
		<span className={classes.headerHelp}>
			Office MLS ID
			<Mui.Tooltip title={OFFICE_ID_HELP}>
				<span className={classes.help} tabIndex={0} aria-label="About Office MLS ID">
					<Icons.Info size={14} />
				</span>
			</Mui.Tooltip>
		</span>
	);
};

export const OfficeIdHeader = withStyles(Component, styles);
